import { RefObject, useEffect, useRef } from "react";
import ResizeObserver from "resize-observer-polyfill";

type UseResizeObserverProps = {
  callback?: (entries: ResizeObserverEntry[]) => void;
  delay?: number;
  element?: RefObject<Element | null>;
};

export const useResizeObserver = (props: UseResizeObserverProps): void => {
  const { callback, delay, element } = props;
  const delayedCallbackTriggered = useRef(false);
  const current = element?.current;
  const observer = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    if (observer.current && current) {
      observer.current.unobserve(current);
    }

    observer.current = new ResizeObserver(handleResize);
    observe();

    return () => {
      if (observer.current && element?.current) {
        observer.current.unobserve(element.current);
      }
    };
  }, [current]);

  function handleResize(event: ResizeObserverEntry[]) {
    if (callback) {
      if (delay) {
        if (!delayedCallbackTriggered.current) {
          delayedCallbackTriggered.current = true;
          globalThis.setTimeout(() => {
            callback(event);
            delayedCallbackTriggered.current = false;
          }, delay);
        }
      } else {
        callback(event);
      }
    }
  }

  function observe() {
    if (element?.current && observer.current) {
      observer.current.observe(element.current);
    }
  }
};
